<template>
  <div>
    <ForeignOrganization
      :v="v"
      :is-alternative-service-edit="isAlternativeServiceEdit"
      :is-manual="false"
      translationKey="noticeRecovery.applicant.foreignOrg"
		>
			<slot></slot>
		</ForeignOrganization>

    <MrpaTrustee
      :v="v.trustee"
      label="Сведения о представителе иностранного юридического лица"
      :role-type="roleValue"
    />
  </div>
</template>

<script>
import { getValidationErrorText } from '@/utils/validate';
import { FieldName } from '@/constants';
import ForeignOrganization, {
  foreignOrganizationModel,
  foreignOrganizationValidation,
} from '../ForeignOrganization';
import MrpaTrustee, {
  mrpaTrusteeModel,
  getMrpaTrusteeValidation,
} from '@/components/services/elements/MrpaTrustee';
import deepmerge from 'deepmerge';
import { Role } from '@/utils/dictionaries';

export const machineForeignOrganizationModel = deepmerge(
  foreignOrganizationModel,
  {
    trustee: mrpaTrusteeModel,
  }
);

export const getMachineForeignOrganizationValidation = (
  foreignOrganization
) => ({
  ...foreignOrganizationValidation,
  trustee: getMrpaTrusteeValidation(foreignOrganization.trustee),
});

export default {
  name: 'MachineForeignOrganization',
  props: {
    v: {
      type: Object,
      required: true,
    },
    isAlternativeServiceEdit: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    ForeignOrganization,
    MrpaTrustee,
  },
  data: () => ({
    getValidationErrorText,
    FieldName,
    roleValue: Role.FOREIGN_ORGANIZATION,
  }),
};
</script>
